
  <button
    #mapfreButton
    [style.color]="textColor"
    [style.background-color]="backgroundColor"
    [style.font-weight]="fw"
    [style.margin-top]="mt + 'px'"
    [ngClass]="{
    'disabled':disabled,
    'primary': type ==='primary',
    'block': expand ==='block',
    'dark': type ==='dark',
    'border-d': type ==='borderD',
    'clear': type ==='clear',
    'link': type ==='link',
    'theme-clear-2': type ==='clearDark'
    }"
    class="mapfre-button__btn flex ai-c jc-c">
    <img width="20"
      *ngIf="icon && slot === 'start'"
      [src]="'assets/icons/'+icon+ '.svg'"
      class="mapfre-mr-s"
      alt="">
    <ng-content *ngIf="!text">
    </ng-content>
    <img width="20"
      *ngIf="icon && slot === 'end'"
      [src]="'assets/icons/'+icon+ '.svg'"
      class="mapfre-ml-s"
      alt="">
    <span *ngIf="text">{{text}}</span>
  </button>
